import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import { SEGMENT } from '@root/app-routing.model';
import { DriverCardService } from '@core/driver-card.service';
import { DriverInfoMessage } from '@core/driver-card.model';

@Injectable()
export class HomeGuard implements CanActivate {
	constructor(
		private readonly router: Router,
		private readonly cardService: DriverCardService
	) {}

	canActivate(): boolean {
		const cardStatus: boolean = this.cardService.cardExisting;
		const driver: DriverInfoMessage | null = this.cardService.driverInfo;
		let shouldActivate: boolean = false;
		if (driver && cardStatus) {
			shouldActivate = true;
		} else {
			this.router.navigate([`/${SEGMENT.CONNECT}`]);
		}
		return shouldActivate;
	}
}
